import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import SimpleReactValidator
    from './SimpleReactValidator';

const useValidator = () => {
    const {
        t,
        i18n,
    } = useTranslation();

    const validator = useMemo(
        () => new SimpleReactValidator(t),
        [
            i18n.resolvedLanguage,
            t,
        ],
    );

    return validator;
};

export default useValidator;